import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo.webp';
import './Footer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    return (
        <div className="footer">
            <div className="first-row">
                <h1>Interesse an einer Beratung?</h1>
                <div className="footer-button">
                    <ul>
                        <li>
                            <Link to="/contact"><strong>JEZT KONTAKT AUFNEHMEN</strong></Link>
                        </li>
                    </ul>
                </div>
            </div>
            <hr />
            <div className="second-row">
                <div className="company-sum">
                    <img src={logo} alt="Logo" />
                    <p>
                    Elektro Thome steht für zuverlässige Elektroinstallationen und moderne Energielösungen. Mit langjähriger Erfahrung bieten wir maßgeschneiderte und nachhaltige Lösungen für private und gewerbliche Kunden. Qualität, Sicherheit und Kundenzufriedenheit stehen bei uns an erster Stelle
                    </p>
                </div>
                <div className="footer-links">
                    <h2>Links</h2>
                    <ul>
                        <li><a href="#">Home</a></li>
                        <li><a href="#">Leistungen</a></li>
                        <li><a href="#">Kontakt</a></li>
                    </ul>
                </div>
                <div className="contact-location">
                    <h2>Kontakt</h2>
                    <div className="contact-info-containers-container">
                        <div className="contact-info-containers">
                            <FontAwesomeIcon icon={faPhone} style={{ color: '#fff' }} />
                            <div className="contact-info-text-containers">
                                <a href="tel:+496887894429">+49 6887 894429</a>
                                <p>Rufen Sie uns an</p>
                            </div>
                        </div>
                        <div className="contact-info-containers">
                            <FontAwesomeIcon icon={faEnvelope} style={{ color: '#fff' }} />
                            <div className="contact-info-text-containers">
                                <a href="mailto:elektro_thome@yahoo.de">elektro_thome@yahoo.de</a>
                                <p>Schreiben Sie uns</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="map">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.8781973350024!2d6.830034038560213!3d49.41819521008005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4795a3e34d018625%3A0x9b20c69ff595f4c5!2sGr%C3%BCbchenstra%C3%9Fe%2048%2C%2066839%20Schmelz%2C%20Germany!5e0!3m2!1sen!2ses!4v1693927275440!5m2!1sen!2ses"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Map Location"
                    ></iframe>
                </div>
            </div>
            <hr />
            <div className="third-row">
                <p>Copyright 2025 | Elektro Thome</p>
                <ul>
                    <li><Link to='/contact' onClick={scrollToTop}>Kontakt</Link></li>
                    <li><Link to='/impressum' onClick={scrollToTop}>Impressum</Link></li> 
                    <li><Link to='/datenschutz' onClick={scrollToTop}>Datenschutzerklärung</Link></li>
                    <li><Link to='/agb' onClick={scrollToTop}>AGB</Link></li>
                </ul>
            </div>
        </div>
    );
}

export default Footer; 